const SeasonModule = {
  firestorePath: 'seasons',
  firestoreRefType: 'collection',
  moduleName: 'SeasonModule',
  statePropName: 'data',
  namespaced: true,
  state: {
    selectedId: null as string | null
  },
  getters: {
    sortedDESC: (state) => {
      return Object.values(state.data).sort(function (a, b) {
        return (b as any).start - (a as any).start
      })
    },
    sortedASC: (state) => {
      return Object.values(state.data).sort(function (a, b) {
        return (a as any).start - (b as any).start
      })
    },
    selected: (state) => {
      if (!state.selectedId) return null
      return state.data[state.selectedId] || null
    }
  },
  mutations: {
    SET_SELECTED_ID (state, id: string | null) {
      state.selectedId = id
    }
  },
  actions: {
    setSelectedId ({ commit, state, getters }, id: string | null) {
      commit('SET_SELECTED_ID', id)
    },
    /**
     * Ensure seasons are loaded and selectedId defaults to the latest season.
     */
    async ensureSelected ({ dispatch, state, getters }) {
      await dispatch('fetchAndAdd')
      const seasons = getters.sortedASC
      if (!seasons.length) {
        return null
      }
      const stillValid = state.selectedId && seasons.some((s: any) => s.id === state.selectedId)
      if (!stillValid) {
        const latest = seasons[seasons.length - 1]
        await dispatch('setSelectedId', latest.id)
        return latest
      }
      return state.data[state.selectedId]
    }
  }
}

export default SeasonModule
